import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";
import {
    FuseProgressBarModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,
} from "@fuse/components";

import { fuseConfig } from "app/fuse-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { SampleModule } from "app/main/sample/sample.module";
import { CotizacionModule } from "./main/apps/cotizacion/cotizacion.module";
import { OOTTModule } from "./main/apps/oott/oott.module";
import { ContratistaModule } from "./main/apps/mantenedores/contratista/contratista.module";
import { PerfilModule } from "./main/apps/perfil/perfil.module";
import { FacturaModule } from "./main/apps/factura/factura.module";
import { ClientesModule } from "./main/apps/mantenedores/clientes/clientes.module";
import { AuthModule } from "@auth0/auth0-angular";
import { ComunasModule } from "./main/apps/mantenedores/comunas/comunas.module";
import { SupervisoresModule } from "./main/apps/mantenedores/supervisores/supervisores.module";

import { AuthHttpInterceptor } from "@auth0/auth0-angular";
import { ErrorInterceptorService } from "./main/apps/shared/services/util/error.interceptor.service";

import { environment as env } from "../environments/environment";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OoccModule } from "./main/apps/oocc/oocc.module";
import { CatalogoServiciosModule } from "./main/apps/mantenedores/catalogo-servicios/catalogo-servicios.module";
import { SharedModule } from "./main/apps/shared/shared/shared.module";
import { DashboardModule } from "./main/apps/dashboard/dashboard.module";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { CustomMatPaginatorIntl } from "./main/apps/shared/services/util/custom.mat-paginator-intl";
import { MAT_DATE_LOCALE } from "@angular/material/core";

const appRoutes: Routes = [
    {
        path: "**",
        redirectTo: "inicio",
    },
];

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: "legacy" }),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        SampleModule,
        CotizacionModule,
        OOTTModule,
        ContratistaModule,
        PerfilModule,
        FacturaModule,
        OoccModule,
        ClientesModule,
        CatalogoServiciosModule,
        DashboardModule,
        ComunasModule,
        SupervisoresModule,

        SharedModule,
        AuthModule.forRoot({
            ...env.auth,
            httpInterceptor: {
                allowedList: [
                    //"https://facilitic-backend-fduyidclpa-uc.a.run.app/api/"
                    "https://facilitic-backend-master-fduyidclpa-uc.a.run.app/api/*",
                    "https://facilitic-backend-tkmrmnuphq-uc.a.run.app/api/*",
                ],
            },
        }),
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptorService,
            multi: true,
        },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },

        {
            provide: MatPaginatorIntl,
            useClass: CustomMatPaginatorIntl,
        },
        { provide: MAT_DATE_LOCALE, useValue: "es" },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
